module.exports = __webpack_public_path__ + "img/qyaq_tsfx.69a05c88.svg";